module.exports = __webpack_public_path__ + "media/images/fa-phone-7c1695b3eec6d938c80dd12fec361bcc.png";